import { useEffect, useRef } from "react";

export default function useScrollToHash(hash: string | null | undefined, setAnchorSelected: (v: string) => void) {
    const scrolledRef = useRef(false);
    const hashRef = useRef<string | null | undefined>(hash);

    useEffect(() => {
        if (!hash) return;

        const auxHash = hash.includes("#") ? hash.split("#")[1] : hash;
        setAnchorSelected(auxHash);

        if (hashRef.current !== hash) {
            hashRef.current = hash;
            scrolledRef.current = false;
        }

        if (scrolledRef.current) return;
        const id = hash.startsWith("#") ? hash.slice(1) : hash;

        const maxAttempts = 10;
        let attempts = 0;

        const intervalId = window.setInterval(() => {
            const el = document.getElementById(id);
            attempts += 1;

            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                scrolledRef.current = true;
                window.clearInterval(intervalId);
            } else if (attempts >= maxAttempts) {
                window.clearInterval(intervalId);
            }
        }, 100);

        return () => window.clearInterval(intervalId);
    }, [hash, setAnchorSelected]);
}
